import script from "./Investment.vue?vue&type=script&setup=true&lang=js"
export * from "./Investment.vue?vue&type=script&setup=true&lang=js"

import "./Investment.vue?vue&type=style&index=0&id=c1e2f396&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1e2f396"]])

export default __exports__